export default "__VITE_PUBLIC_ASSET__26b33337__"